import { useLazyQuery } from '@apollo/client';
import { customersApi } from '../api';
import { APIRequestPagination, APIRequestSort } from 'global';
import { useDebounce } from 'hooks/useDebounce';
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Account } from '@trnsact/trnsact-shared-types';
import { formatCustomersToTableData } from '../lib';

export function useCustomersPage(searchTerm: string, pagination: APIRequestPagination, sorting?: APIRequestSort) {
  const account = useSelector((state: any) => state.account) as Account;

  const debouncedSearchTerm = useDebounce(searchTerm);

  const [getCustomers, { data: customersData, loading }] = useLazyQuery(customersApi.getCustomers);

  const input = useMemo(() => {
    return {
      accountId: account.id,
      offset: (pagination.page - 1) * pagination.perPage,
      limit: pagination.perPage,
      searchTerm: debouncedSearchTerm.trim().length > 2 ? debouncedSearchTerm : undefined,
      sorting,
    };
  }, [debouncedSearchTerm, pagination, sorting]);

  useEffect(() => {
    getCustomers({ variables: { input } });
  }, [input, getCustomers]);

  return {
    isLoading: loading,
    customers: formatCustomersToTableData(customersData?.customer?.customersByAccountId?.list ?? []),
    total: customersData?.customer?.customersByAccountId?.total ?? 0,
  };
}
